import { GlobalUtil } from '@xl/js-utils';
import watchdogVuePlugin from '@xl/watch-dog-jsutil/lib/vue-plugin';

export default function (Vue) {
  // 初始化前端监控
  GlobalUtil.initWatchdog();
  // 为了捕获到 Vue 内部错误
  Vue.use(watchdogVuePlugin);
}
